/**
 * Tiny context flag: true when a screen renders INSIDE the desktop sidebar
 * shell (components/shell/DesktopShell). The TopBar reads it to drop its own
 * brand lockup on desktop — the sidebar already shows "bero", so repeating it in
 * every content header is redundant. Kept in its own module so both @/ui
 * (TopBar) and the shell can import it without a cycle.
 */
import React from 'react';

const InShellContext = React.createContext(false);

export function InShellProvider({ children }: { children: React.ReactNode }) {
  return <InShellContext.Provider value={true}>{children}</InShellContext.Provider>;
}

export function useInShell(): boolean {
  return React.useContext(InShellContext);
}
